var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8 6.8a3.32 3.32 0 0 0-4.7 0l-23 23.4-7.3-7.3a3.32 3.32 0 0 0-4.7 0 3.32 3.32 0 0 0 0 4.7l9.6 9.7c.6.6 1.5 1 2.3 1s1.6-.3 2.3-1l25.5-25.8c1.3-1.2 1.3-3.4 0-4.7z"
  })));
};
export default SvgCheckmark;